export default __webpack_public_path__ + "static/media/opname.30258a32.png";